/**
 * Central sidebar navigation config.
 * Each item declares `perm` — the permissions_v2 module key that controls
 * visibility. The Sidebar filters via hasPermission(perm, 'view'), so a
 * user's navigation always mirrors their permission matrix.
 */
import {
  LayoutDashboard, FolderOpen, DollarSign, TrendingDown, UserCog,
  LayoutGrid, Package, Boxes, Wrench, Heart, GraduationCap, Trophy,
  HeartHandshake, Landmark, Wheat, ClipboardList, ScrollText, Database,
  ClipboardCheck, Target, Archive, Banknote, Wallet,
} from 'lucide-react';

export const mainNavItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', perm: 'dashboard' },
  { icon: FolderOpen, label: 'Documents & Forms', path: '/documents', perm: 'documents' },
];

export const financeSubItems = [
  { icon: LayoutDashboard, label: 'Overview', path: '/finance/overview', perm: 'finance' },
  { icon: DollarSign, label: 'Income', path: '/finance/income', perm: 'finance' },
  { icon: TrendingDown, label: 'Expenses', path: '/finance/expenses', perm: 'finance' },
  { icon: Wallet, label: 'Salaries', path: '/finance/salaries', perm: 'payroll' },
  { icon: Target, label: 'Budgets', path: '/finance/budgets', perm: 'finance' },
  { icon: ClipboardCheck, label: 'Requisitions & Approvals', path: '/finance/approvals', perm: 'requisitions' },
  { icon: Archive, label: 'Year Archive', path: '/finance/archive', perm: 'finance' },
];

export const personnelSubItems = [
  { icon: UserCog, label: 'Staff', path: '/staff', perm: 'personnel' },
];

export const studentDirectoryItems = [
  { label: 'Suubi Primary School', path: '/sis/students/primary' },
  { label: 'Suubi Secondary School', path: '/sis/students/secondary' },
];

export const assetsSubItems = [
  { icon: LayoutGrid, label: 'Dashboard', path: '/assets/dashboard', perm: 'assets' },
  { icon: Package, label: 'Asset Register', path: '/assets/list', perm: 'assets' },
  { icon: Boxes, label: 'Inventory', path: '/assets/inventory', perm: 'assets' },
  { icon: Wrench, label: 'Maintenance', path: '/assets/maintenance', perm: 'assets' },
];

// SCHOOLS Umbrella: school programs and school-related operations
export const schoolPrograms = [
  { icon: Banknote, label: 'School Fees Collection', path: '/schools/fees', perm: 'school_fees' },
  { icon: Heart, label: 'Child Sponsorship', path: '/sponsorship', perm: 'sponsorship' },
  { icon: GraduationCap, label: 'Vocational Training', path: '/training', perm: 'training' },
  { icon: Trophy, label: 'School Clubs', path: '/school-clubs', perm: 'school_clubs' },
  { icon: HeartHandshake, label: 'Catch-up Learning', path: '/catchup', perm: 'catchup' },
];

// WOMEN'S Programs Umbrella
export const womenPrograms = [
  { icon: LayoutDashboard, label: 'Program Overview', path: '/women/overview', perm: 'projects' },
  { icon: Landmark, label: 'Loans Program', path: '/loans', perm: 'loans' },
  { icon: Wheat, label: 'Maize Buy-back', path: '/maize', perm: 'maize' },
];

// Project type → umbrella mapping for dynamic projects
export const SCHOOL_PROJECT_TYPES = ['school_garden', 'chicken_farming'];
export const WOMEN_PROJECT_TYPES = ['masonry', 'women_development'];

export const bottomNavItems = [];

// Super Admin section (only super_admin sees this)
export const adminSubItems = [
  { icon: UserCog, label: 'User Management', path: '/admin/users' },
  { icon: ClipboardList, label: 'Data Entry Access', path: '/admin/data-entry-access' },
  { icon: ScrollText, label: 'Audit Log', path: '/admin/audit' },
  { icon: Database, label: 'Data Management', path: '/admin/data-management' },
];
